export const tabsData = [
    {
        label: 'Payments',
        path: '/invoices/payments',
    },
    {
        label: 'Watchlist',
        path: '/invoices/watchlist',
    },
    {
        label: 'Credentials',
        path: '/invoices/credentials',
    },
    {
        label: 'Payments Upload',
        path: '/invoices/payments-upload',
    },
    {
        label: 'Invoices Upload',
        path: '/invoices/invoices-upload',
    },
];
